import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "pramid_admin_token";
const CUSTOMER_KEY = "pramid_customer";
const ADMIN_ROLE_KEY = "pramid_admin_role";
const ADMIN_NAME_KEY = "pramid_admin_name";

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => { localStorage.removeItem(ADMIN_TOKEN_KEY); localStorage.removeItem(ADMIN_ROLE_KEY); localStorage.removeItem(ADMIN_NAME_KEY); };
export const setAdminSession = ({ token, role, name }) => { setAdminToken(token); localStorage.setItem(ADMIN_ROLE_KEY, role || "staff"); localStorage.setItem(ADMIN_NAME_KEY, name || ""); };
export const getAdminRole = () => localStorage.getItem(ADMIN_ROLE_KEY) || "admin";
export const getAdminName = () => localStorage.getItem(ADMIN_NAME_KEY) || "";

export const getCustomer = () => {
  const raw = localStorage.getItem(CUSTOMER_KEY);
  return raw ? JSON.parse(raw) : null;
};
export const setCustomer = (c) => localStorage.setItem(CUSTOMER_KEY, JSON.stringify(c));
export const clearCustomer = () => localStorage.removeItem(CUSTOMER_KEY);

export const api = axios.create({ baseURL: API });

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = getAdminToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fmtTRY = (v) =>
  new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    maximumFractionDigits: 2,
  }).format(Number(v) || 0);

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};
